import React from 'react';
import PropTypes from 'prop-types';
import ReactTypeahead from 'react-typeahead';
import UiComponent from '../UiComponent';

export default class InputAutocomplete extends UiComponent {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(value) {
    this.props.field.value = value;
    if (this.props.relatedTo && this.props.relatedTo.length > 0) {
      this.props.onChange([
          this.props.relatedTo,
          this.props.field.name,
        ],
        this.props.field
      );
    } else {
      this.props.onChange(this.props.field.name, this.props.field);
    }
  }

  render() {
    const containerClass = `form-group ${this.props.className}`;
    let disabled = false;
    if (this.getFieldProp('system') && this.getFieldProp('system').disabled) {
      disabled = true;
    }
    return (
      <div className={containerClass}>
        {this.getLabel()}
        <ReactTypeahead.Typeahead
          disabled={this.props.disabled}
          options={this.props.options}
          showOptionsWhenEmpty={true}
          maxVisible={10}
          placeholder={this.getFieldProp('placeholder')}
          inputProps={{autoComplete: "nope"}}
          customClasses={{
            input: "form-control",
            results: "topcoat-list__container list-group",
            listItem: "topcoat-list__item list-group-item"
          }}
          ref='typeahead'
          onOptionSelected={(value) => {
            this.refs.typeahead.refs.entry.blur();
            this.refs.typeahead.refs.entry.focus();
            this.changeValue(value);
          }}
          onChange={
            e => {
              this.refs.typeahead.refs.entry.blur();
              this.refs.typeahead.refs.entry.focus();
              this.changeValue(e.target.value);
            }
          }
          value={this.getFieldProp('value')}
        />
        {this.getErrors()}
      </div>
    );
  }
}

InputAutocomplete.propTypes = {
  relatedTo: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.object,
  options: PropTypes.array,
  field: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/InputAutocomplete/index.js